module.exports = __webpack_public_path__ + "static/media/angular.202b90d0.svg";